import { cn } from "~/lib/utils";
import Img from "../UI/Img";
import type { ShowcaseCardProps } from "./types";
import { forwardRef } from "react";
import Link from "../UI/Link";
import { buttonVariants } from "../UI/Button";

const ShowcaseInlineCard = forwardRef<HTMLDivElement, ShowcaseCardProps>(
  (props, ref) => {
    return (
      <div className="flex flex-col gap-16">
        <div
          className={cn("flex items-center gap-4", props.className)}
          ref={ref}
          style={props.style}
        >
          <div
            className={cn(
              "rounded-full flex-shrink-0 self-start",
              props.size === "sm" ? "p-2" : "p-4",
              props.theme === "dark"
                ? "dark relative bg-primary backdrop-grayscale-0 shadow-[0_0px_20px_-3px_hsla(var(--secondary)/_0.15)]"
                : "bg-white shadow-[0_0px_20px_-3px_hsla(var(--secondary)/_0.15)]",
            )}
          >
            {props.theme === "dark" && (
              <div className="absolute inset-0 rounded-full bg-black z-[-1] opacity-10" />
            )}
            <Img
              src={props.icon}
              alt={props.title}
              className={props.size === "sm" ? "size-3" : "size-5"}
              width={32}
              height={32}
            />
          </div>

          <div
            className={cn(
              "flex flex-col gap-1",
              "max-lg:items-center max-lg:text-center",
            )}
          >
            {props.beforeTitle}
            <h3 className="text-lg font-bold ">{props.title}</h3>
            <p className="max-w-[350px] text-sm ">{props.description}</p>
            {props.cards && (
              <div className="flex gap-2 mt-5"
                {...props.cards}
               
              />
            )}
            {props.cta && (
              <Link
                {...props.cta}
                className={buttonVariants({
                  variant: "secondary",
                  className:
                    "uppercase tracking-widest w-fit flex mt-4 lg:hidden",
                })}
              />
            )}
          </div>
        </div>

        {props.cta && (
          <Link
            {...props.cta}
            className={buttonVariants({
              variant: "secondary",
              className: "uppercase tracking-widest w-fit hidden lg:flex",
            })}
          />
        )}
      </div>
    );
  },
);

ShowcaseInlineCard.displayName = "ShowcaseInlineCard";

export default ShowcaseInlineCard;
